import theme from '../../../lib/theme';
import { CarouselItemProps } from './CarouselItem';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  carouselItem: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '360px',
    width: '100%',
    color: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    overflow: 'hidden',
    
    [media.l.down]: {
      height: 500,
    },
    [media.s.down]: {
      height: 400,
    },
  },
});
